define('modules/uv-shared-module/AnnotationResults',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AnnotationResults = /** @class */ (function () {
        function AnnotationResults() {
        }
        return AnnotationResults;
    }());
    exports.AnnotationResults = AnnotationResults;
});
//# sourceMappingURL=AnnotationResults.js.map
